"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.string.includes.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _usePrefixCls = require("../_utils/hooks/usePrefixCls");
var _controlled = require("../Form/controlled");
var _excluded = ["value", "onChange", "disabled", "layout", "style", "className", "children", "defaultValue"];
var RadioGroup = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var _useDefaultValue = (0, _controlled.useDefaultValue)(props, ''),
    value = _useDefaultValue.value,
    onChange = _useDefaultValue.onChange,
    disabled = _useDefaultValue.disabled,
    layout = _useDefaultValue.layout,
    style = _useDefaultValue.style,
    className = _useDefaultValue.className,
    children = _useDefaultValue.children,
    defaultValue = _useDefaultValue.defaultValue,
    htmlProps = (0, _objectWithoutProperties2.default)(_useDefaultValue, _excluded);
  var prefixCls = (0, _usePrefixCls.usePrefixCls)('radio__group');
  var classes = (0, _classnames.default)(prefixCls, className);
  var handleChange = function handleChange(check, e) {
    var currentValue = e.radio.name;
    var currentChecked = check;
    var radioedValue = value || '';
    if (currentChecked && !radioedValue.includes(currentValue)) {
      radioedValue = currentValue;
    }
    onChange === null || onChange === void 0 ? void 0 : onChange(radioedValue, e);
  };
  var renderRadio = function renderRadio() {
    var display = layout === 'column' ? 'block' : 'inline';
    var childrenArr = [];
    if (children) {
      _react.default.Children.forEach(children, function (child) {
        var childProps = child.props;
        childrenArr.push( /*#__PURE__*/_react.default.cloneElement(child, {
          value: value.includes(childProps.name) || childProps.value,
          onChange: handleChange,
          key: childProps.name,
          disabled: disabled || childProps.disabled,
          display: display
        }));
      });
    }
    return childrenArr.length > 0 ? childrenArr : null;
  };
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: classes,
    style: style,
    ref: ref
  }, htmlProps), renderRadio());
});
var _default = exports.default = RadioGroup;